import React, { memo, useEffect, useState } from 'react';

import { HEADER_HEIGHT } from '../../constants/common';

interface IScrollProgressProps {
  container: HTMLDivElement;
}

export const ScrollProgress = memo<IScrollProgressProps>(({ container }) => {
  const [scroll, setScroll] = useState(0);

  const updateProgressBar = () => {
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const scrollTop = Math.abs(containerRect.top - HEADER_HEIGHT);
    const winHeight = window.innerHeight;
    const scrollPercent = scrollTop / (containerRect.height - winHeight);
    const scrollPercentRounded = Math.round(scrollPercent * 100);

    window.requestAnimationFrame(() => {
      setScroll(scrollPercentRounded);
    });
  };

  useEffect(() => {
    document.addEventListener('scroll', updateProgressBar);
    updateProgressBar();
    return () => document.removeEventListener('scroll', updateProgressBar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [container]);

  const translateX = scroll >= 100 ? 0 : -100 + scroll;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        height: 1.5,
        zIndex: 2,
        top: 0,
        backgroundColor: '#00afff',
        width: '100vw',
        transform: `translateX(${translateX}%)`,
        transition: 'transform 200ms linear',
      }}
    />
  );
});
